import { CoreIndexer } from './core-indexer/core-indexer';
import { VotesIndexer } from './votes-indexer/votes-indexer';
import { ErrorsIndexer } from './errors-indexer/errors-indexer';

let coreIndexer: CoreIndexer | null = null;
let votesIndexer: VotesIndexer | null = null;
let errorsIndexer: ErrorsIndexer | null = null;

export const createIndexers = (coreUrl: string, votesUrl: string, errorsUrl: string) => {
  if (coreUrl === coreIndexer?.url) {
    console.info(`Core Indexer already initialized with url: ${coreUrl}`);
  } else {
    coreIndexer = new CoreIndexer(coreUrl);
  }

  if (votesUrl === votesIndexer?.url) {
    console.info(`Votes Indexer already initialized with url: ${votesUrl}`);
  } else {
    votesIndexer = new VotesIndexer(votesUrl);
  }

  if (errorsUrl === errorsIndexer?.url) {
    console.info(`Errors Indexer already initialized with url: ${errorsUrl}`);
  } else {
    errorsIndexer = new ErrorsIndexer(errorsUrl);
  }
};

export const getCoreIndexer = () => {
  if (!coreIndexer) {
    throw new Error('Core indexer is not initialized.');
  }
  return coreIndexer;
};

export const getVotesIndexer = () => {
  if (!votesIndexer) {
    throw new Error('Votes indexer is not initialized.');
  }
  return votesIndexer;
};

export const getErrorsIndexer = () => {
  if (!errorsIndexer) {
    throw new Error('Errors indexer is not initialized.');
  }
  return errorsIndexer;
};

export const reloadIndexers = (coreUrl: string, votesUrl: string, errorsUrl: string) => {
  coreIndexer = null;
  votesIndexer = null;
  errorsIndexer = null;
  createIndexers(coreUrl, votesUrl, errorsUrl);
};
